import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { BaseCoreState, BaseDocumentsService, CustomerOfferType, DocumentListItemResponseExtended } from 'base';

@Component({
  selector: 'base-customer-offer-documents-tab',
  templateUrl: 'base-customer-offer-documents-tab.component.html',
})
export class BaseCustomerOfferDocumentsTabComponent implements OnInit, OnDestroy {
  @Input() offer: CustomerOfferType | undefined;
  documentList: Array<DocumentListItemResponseExtended> = [];
  documentCategories: { value: number; label: string }[] = [];

  private destroy$ = new Subject<boolean>();

  constructor(private store: Store<BaseCoreState>, private baseDocumentsService: BaseDocumentsService) {}

  ngOnInit() {
    this.getDocumentsCategories();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private getDocumentsCategories() {
    this.baseDocumentsService
      .getDocumentCategories$('offer')
      .pipe(takeUntil(this.destroy$))
      .subscribe((categories) => {
        this.documentCategories = categories;

        if (this.offer) {
          this.documentList = this.offer.documents.map((document) => {
            return {
              ...document,
              categoryLabel: this.documentCategories.find((category) => category.value === document.category)?.label,
            };
          });
        }
      });
  }
}
